import React from "react";
import AnimatedItem from "./animateditem.tsx";

function AnimatedList({ items, active, reset}){
    return (
        <div className={` grid-cols-3 pt-10 pb-10 gap-4 justify-items-center w-2/3 m-auto ${active ? 'grid': 'hidden'}`}>
            {items.map((item, index) => (
                <AnimatedItem 
                key={index} 
                item={item} 
                delay_seconds={0.05 + index * 0.1}
                reset={reset}
                />
            ))}
        </div>
    );
};
export default AnimatedList;